/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import { connect } from 'react-redux';
import Select from 'react-select';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import { PanelStyle } from '../../constants';
import history from '../../core/history';
import ModalAlert from './ModalAlert';
import _ from 'lodash';
import ProgressBar from 'react-bootstrap/lib/ProgressBar';

import v from './validators';

const {
  errorSpanStyle,
} = PanelStyle;


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const mpzpOwnerDict = {
  FirstName: {
    label: 'Imię',
    editable: true,
  },
  LastName: {
    label: 'Nazwisko:',
    editable: true,
  },
  CompanyName: {
    label: 'Firme:',
    editable: true,
  },
  AddressCity: {
    label: 'Miejsowość:',
    editable: true,
  },
  AddressStreet: {
    label: 'Ulica:',
    editable: true,
  },
  AddressNumber: {
    label: 'Numer budynku:',
    editable: true,
  },
  AddressFlat: {
    label: 'Numer lokalu:',
    editable: true,
  },
  AddressZipCode: {
    label: 'Kod pocztowy:',
    editable: true,
  },
};

class LudnoscMiejscowosc extends React.Component {
  state = {
    info: {
      miejscowosc: null,
    },
    jobId: null,
    isWorking: false,
    progress: 0,
    cities: null,
    choosedCity: null,
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
  };

  spanStyle = {
    color: 'red',
  };

  validators = {
    miejscowosc: [v.NotSelected]
  };

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservices/${this.props.district}/cities`)
    .then(r => r.json())
    .then(resp => {
      this.setState({
        cities: resp.cities
      })
    })
  }

  onHide = () => this.setState({ showError: false });

  onChangeSelect = (e) => {
    this.setState({
      choosedCity: e.value,
      info: {
        ...this.state.info,
        miejscowosc: e.value
      }
    },
      () => this.validate('info', 'miejscowosc'))
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true
      });
      return;
    }

    if (!hasFieldErrors) {
      this.runService()
    }
  }

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  runService = () => {
    if (this.state.choosedCity === null)
      return;

    // /eservices/<string:teryt>/service/<string:serviceType>
    const url = `${process.env.API_URL}/eservices/${this.props.district}/service/${this.props.serviceInfo.eservice.shortName}`;
    let data = {
      'dzialki': [],
      'shortName': this.props.serviceInfo.eservice.shortName,
      'city': this.state.choosedCity
    }

    const odp = fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(r => {
      if (r.status === 200) {
        return r.json();
      }
      throw new Error('Blad');
    })
    .then(resp => {
      // returnsDoc: true,
      if (this.props.serviceInfo.eservice.returnsDoc) {
        window.location.href = `${process.env.API_URL}/eservices/${this.props.district}/getDoc/${resp.fileName}`;
      } else {
        this.setState({ jobId: resp.message, isWorking: true }, () => this.getJobStatus());
      }
    })
    .catch(err => {
      // TODO: create modal info, with message: Błąd po stronie serwera wróc za 10 min
      console.info('HABIBI07: err', err);
    });
  }

  getJobStatus = () => fetch(`${process.env.API_URL}/service/status/${this.state.jobId}`, { method: 'GET' })
  .then(r => r.json())
  .then(resp => {
    this.setState(
    { jobStatus: resp, progress: this.state.progress !== 99 ? this.state.progress + 0.5 : 99, modalBody: <div>
      <ProgressBar active now={this.state.progress} label={`${this.state.progress}%`} />
      <p>
        Trwa generowanie Twojego dokumentu, w zależności od złożoności dokumentu generowanie może trwać od 30s do około 2 minut.
      </p>
    </div>, modalText: 'Generowanie dokumentu...' },
    () => {
        if (resp.status === 'started') {
          setTimeout(this.getJobStatus, 50); //: (resp.status === 'finished') ? this.onJobFinish(resp) : this.setState({ isWorking: false })
        }
        if (resp.status === 'finished') {
          this.onJobFinish(resp);
        }
        if (resp.status === 'failed'){
          this.onJobFailed()
        }

      })
    }
  );

  render() {
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <GrayPanel
          title={'1. Miejsowość'}
        >
          <p>Wybierz Miejsowość</p>
          <Select
            placeholder="Wybierz z listy..."
            options={this.state.cities ? this.state.cities : null}
            value={this.state.choosedCity}
            onChange={(e) => this.onChangeSelect(e)}
            style={{
              borderColor:
                Object.keys(this.state.errors).indexOf("miejscowosc") > -1 &&
                  this.state.errors["miejscowosc"] !== null &&
                  this.state.errors["miejscowosc"].length > 0
                  ? 'red'
                  : '#ccc',
            }}
          />
          {Object.keys(this.state.errors).indexOf("miejscowosc") > -1 &&
            this.state.errors["miejscowosc"] !== null &&
            this.state.errors["miejscowosc"].length > 0 ?
            <span key={Object.keys(this.state.errors).indexOf("miejscowosc")} style={{
              color: 'red',
              fontSize: '10px'
            }}>
              {this.state.errors["miejscowosc"]}
            </span> : null}
        </GrayPanel>

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ progress: 0 }, () => this.startService())}
            >
              Uruchom
            </button>
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

LudnoscMiejscowosc.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default connect(mapState, mapDispatch)(LudnoscMiejscowosc);



// WEBPACK FOOTER //
// src/routes/eservices/LudnoscMiejscowosc.js